import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "@/store/reducers";

export const selectCurrentBoat = createSelector(
  [(state: RootState) => state.user.vessels, (state: RootState) => state.user.userInformation],
  (vessels, userInformation) =>
    vessels.find((vessel) => vessel.current) || (userInformation?.current_vessel ?? null),
);
